import { environment } from '../../environments/environment';
import { forkJoin, fromEvent, merge, Observable, Subscription } from 'rxjs';
// import { ILookup } from "./../shared/lookup";
import { DomSanitizer } from '@angular/platform-browser';
import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChildren,
    ViewChild,
    ElementRef,
    HostListener,
} from '@angular/core';
import {
    //NgForm,
    FormControl,
    FormBuilder,
    FormGroup,
    FormArray,
    Validators,
    FormControlName
} from '@angular/forms';

import { ClearanceItem, CIRestriction, CIDocument, CITag, ClearanceItemTagComponent } from './index';
import { ClearanceItemService } from './clearance-item.service';
import { ILookup, LookupList } from '../shared/lookup';
import { ActivatedRoute, Router } from '@angular/router';

import { Location } from "@angular/common";
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { ComponentCanDeactivate, MessageBrokerService, AuthService } from '../shared/core/index';
import { AppService } from '../app.service';
import { GenericValidator } from "../shared/generic-validator";

import { Guid, DateUtils, SharedUtils, AppUtils } from '../shared/utils';
import { CIImage } from './clearance-item.model';
import { ClearanceItemAssetManagerComponent } from './asset-management/clearance-item-asset-manager.component';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { AbstractControl } from '@angular/forms';
import { ModalPromptService, PromptOptions } from '../shared/helper-components/modal-prompt.service';
import { OnDestroy } from '@angular/core';
import { ProjectService } from '../project/project.service';
import { IProject } from '../project/project.model';
import { NavigationTrackerService } from '../shared/helper-components/navigation-tracker.service';
import { PENDING_STATUSES } from '../shared/helper-components/constants';
import { NotesPanelComponent } from './notes-panel/notes-panel.component';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { first } from 'rxjs/internal/operators/first';

@Component({
    selector: 'clearance-item',
    standalone: false,
    templateUrl: './clearance-item.component.html',
    styleUrls: ['./clearance-item.component.css']
})
export class ClearanceItemComponent implements OnInit, AfterViewInit, ComponentCanDeactivate, OnDestroy {

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        if (this.promptSubscription && !this.promptSubscription.closed) {
            this.promptSubscription.unsubscribe();
        }
    }

    onNotesRead(): void {
        if (this.clearanceItem) {
            this.clearanceItem.unreadNotesCount = 0;
        }
    }

    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    @ViewChild('imageAsset', { static: false }) imageComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('imageRefAsset', { static: false }) imageRefComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('documentAsset', { static: false }) documentComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('tagComponent', { static: true }) tagComponent: ClearanceItemTagComponent;
    @ViewChild('newTitle', { static: false }) newTitle: ElementRef;
    @ViewChild('itemNameInput', { static: false }) itemNameInput: ElementRef;
    @ViewChild(NotesPanelComponent, { static: false }) notesPanel: NotesPanelComponent;

    pageTitle: string = 'Clearance Item Edit';
    errorMessage: string;
    clearanceItemForm: FormGroup = new FormGroup({});
    isFormReady: boolean = false;
    projectId: string;
    clearanceItem: ClearanceItem = new ClearanceItem();
    statusLookup: ILookup[] = [];
    globalTags: CITag[] = [];
    allRestrictions: CIRestriction[] = [];
    images: CIImage[] = [];
    documents: CIDocument[] = [];
    largeImage: any;
    loadingLargeImage: boolean;
    reportGroupName = new FormControl();
    filteredReportGroups: string[] = [];
    searchResults: ILookup[];
    autosave = false;
    updatedCIName: string;
    initialDefaultTitle: string;
    projectDepartment: string = "";
    isNewCI: boolean = false;
    openCarouselImageIndex: number;
    openCarouselAssetType: string;
    params = []
    modelParams = [
        {
            dismissible: false,
            complete: function () { console.log('Closed'); }
        }
    ]
    allowedStatusesForProductionUsers = new Set([
        'NEW',
        'PENDING - Updated by Production'
    ]);

    visibleStatusLookup: any[] = []
    statusChangeComments: string;
    showStatusChangeModal: boolean = false;
    showDeleteBtn: boolean = false;
    showCopyBtn: boolean = true;
    showSpinner: boolean = false;
    isClearanceUser: boolean;
    //Form Validations
    displayMessage: { [key: string]: string } = {};
    genericValidator: GenericValidator;

    validationMessages = {
        'name': {
            'required': 'Please Enter Item Title.',
            'minlength': 'Title Must be at Least 4 Characters Long.',
            'maxlength': 'Name Cannot be More than 80 Characters Long.'
        },
        'selectedTags': {
            'minLengthArray': 'At least one tag must be selected',
        },
        'episode': {
            'required': 'Please Enter Episode.',
        },
    };
    titleList: ILookup[] = [];

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private _notificationsService: NotificationsService,
        private _messageBrokerService: MessageBrokerService,
        private _clearanceItemService: ClearanceItemService,
        private _projectService: ProjectService,
        private _appService: AppService,
        private _authService: AuthService,
        private location: Location,
        public sanitizer: DomSanitizer,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private navigationTracker: NavigationTrackerService
    ) {

        this.genericValidator = new GenericValidator(this.validationMessages);
        let routeItems = this.router.url.split('/');
        // if (routeItems.length > 0){
        //     this.rootUrl = routeItems[1];
        // }else{
        this.rootUrl = 'projects';
        // }

    }

    sub: Subscription;
    rootUrl: string;

    ngOnInit(): void {

        this.isClearanceUser = this._authService.isUserInRole(environment.clearanceRole);// || !environment.production;
        // // Read the clearance Id from the route parameter
        this.sub = this.route.params.subscribe(
            params => {
                this.showDeleteBtn = false;
                this.showCopyBtn = false;
                this.isFormReady = false;
                this.initForm();
                this.isFormReady = true;
                this.clearanceItem = new ClearanceItem();
                this.clearanceItem.status = this._authService.secondApproval ? 'APPROVAL PENDING' : 'NEW';
                let id = params['ciId'];
                let projectId = params['projectId'];
                this.projectId = projectId;
                this.openCarouselAssetType = params['assetType'];
                this.openCarouselImageIndex = parseInt(params['imageIndex']);
                if (id && id != 'new') {
                    this.getClearanceItem(id);
                    this.isNewCI = false;
                }
                else {
                    this.pageTitle = 'New Item';
                    this.isNewCI = true;
                    this.clearanceItem.isCreatedByProd = false;
                    this.loadCILookups();
                    window.scrollTo(0, 0);
                    this.focusItemName();
                }
                this._projectService.getProject(this.projectId)
                .subscribe((project: IProject) => {
                        this.projectDepartment = project.department;
                        this._appService.updateProjectHeader(projectId, project.name);
                        this.setEpisodeValidation();
                    },
                    (error: any) => {
                        this.errorMessage = <any>error;
                        this._errorHandler.processError(error);
                    }
                );
                this.ProcessSearch();
            }
        );
    }

    onItemDeleted(event: { itemIndex: number, child: ClearanceItemAssetManagerComponent }) {
        if (!this.isClearanceUser && this.clearanceItem.status != 'NEW'
            && this.clearanceItem.status != 'PENDING - Updated by Production'
            && this.clearanceItem.status != 'PENDING - Modifications Required'
            && this.clearanceItem.status != 'PENDING - Production Info Required') {
            this._notificationsService.add(new Notification('info', 'You are not allowed to remove the image.'));
        } else {
            event.child.executeRemoveItem(event.itemIndex);
        }
    }


    newTagAdded(tag: FormGroup): void {
        
        if (tag) {
            if (!this.isClearanceUser && tag.controls.tagType.value == 'Custom' && this.clearanceItemForm.controls['status'].value != 'NEW') {
                this._notificationsService.add(new Notification('info', 'You do not have access to select custom tag'));
                return;
            }
            // this.SelectedTags.setValue(this.mapItems(tag))
            tag.controls.isSelected.setValue(!tag.controls.isSelected.value);
            // console.log('togleTagSelection(tag), tag:' + JSON.stringify(tag.value));
            // console.log('form.tags:' + JSON.stringify(this.clearanceItemForm.controls.tags.value));

            this.UpdateSelectedTags(tag);

            this.clearanceItemForm.controls.selectedTags.markAsDirty()
            this.clearanceItemForm.controls.selectedTags.updateValueAndValidity();
        }
    }

    globalTagAdded(tag: FormGroup): void {
        this.UpdateSelectedTags(tag);
        this.clearanceItemForm.markAsDirty();
    }

    UpdateSelectedTags(tag: FormGroup) {
        
        if (!tag)
            return;

        if (!tag.controls.isSelected.value) {
            let sc = this.SelectedTags.controls.findIndex(c => c.get('tagId').value == tag.controls.tagId.value);
            this.SelectedTags.removeAt(sc);
        } else {
            //check if this is a recent tag that has not been assigned an id yet but it might have been entered before on this session.
            if (tag.controls.tagId.value == null) {
                //Since a new tag could have an empty id, we need to look for name to avoid duplicate entries.
                let sc = this.SelectedTags.controls.findIndex(c => c.get('tagName').value == tag.controls.tagName.value);
                if (sc != -1) {
                    return;
                }
            }

            this.SelectedTags.push(tag);
            this.SelectedTags.markAsDirty();
        }
    }

    toggleNotesPanel(): void {
        if (this.notesPanel) {
            this.notesPanel.toggle();
        }
    }

    showHistory(e: Event): void {
        if (this.clearanceItem && this.clearanceItem.id) {
            this.router.navigateByUrl('/' + this.rootUrl + '/' + this.projectId + '/items/' + this.clearanceItem.id + '/history');
        }
    }

    initForm(): void {
        var initialStatus = this._authService.secondApproval ? 'APPROVAL PENDING' : 'NEW';
        this.clearanceItem.status = initialStatus;
        this.clearanceItemForm = this.fb.group({
            id: '',
            name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(80)]],
            status: initialStatus,
            description: '',
            scene: '',
            episode: '',
            season: '',
            copyrightInfo: '',
            artistAuthorName: '',
            refUrl: '',
            isCreatedByProd: false,
            deadline: null,
            ciUniqueId: '',
            reportGroupName: '',
            titles: this.fb.array([]),
            tags: this.fb.array(this.tagComponent ? this.tagComponent.initTags() : []),
            restrictions: this.fb.array(this.initRestrictions()),
            images: this.fb.array(this.imageComponent ? this.imageComponent.initAssets() : []),
            imagesRef: this.fb.array(this.imageRefComponent ? this.imageRefComponent.initAssets() : []),
            documents: this.fb.array(this.documentComponent ? this.documentComponent.initAssets() : []),
            selectedTags: this.fb.array([], ClearanceItemComponent.minLengthArray(1, this.isClearanceUser))
        });

        this.statusChanged();
        this.setStatusControlState();
    }

    get SelectedTags(): FormArray {
        return <FormArray>this.clearanceItemForm.controls['selectedTags'];
    }

    updateForm(): void {

        this.formFullyLoaded = false;

        var disabled = false;
        this.clearanceItemForm.patchValue({
            id: this.clearanceItem.id,
            name: this.clearanceItem.name,
            status: this.clearanceItem.status,
            description: this.clearanceItem.description,
            scene: this.clearanceItem.scene,
            episode: this.clearanceItem.episode,
            season: this.clearanceItem.season,
            copyrightInfo: this.clearanceItem.copyrightInfo,
            artistAuthorName: this.clearanceItem.artistAuthorName,
            refUrl: this.clearanceItem.refUrl,
            isCreatedByProd: this.clearanceItem.isCreatedByProd,
            deadline: DateUtils.toFormDate(this.clearanceItem.deadline),
            ciUniqueId: this.clearanceItem.ciUniqueId,
            reportGroupName: this.clearanceItem.reportGroupName,
            selectedTags: []
        });
        let tags = <FormArray>this.clearanceItemForm.controls['tags'];
        let selectedTags = <FormArray>this.clearanceItemForm.controls['selectedTags'];

        if (tags && tags.controls && tags.controls.length > 0) {
            tags.controls = [];
        }
        if (selectedTags && selectedTags.controls && selectedTags.controls.length > 0) {
            selectedTags.controls = [];
        }

        if (this.globalTags) {
            this.globalTags.forEach(tag => {
                tag.isSelected = false; //by default
                const fb = this.tagComponent ? this.tagComponent.initTag(tag) : this.fb.group(tag);
                if (this.clearanceItem.tags && this.clearanceItem.tags.find(t => t.tagId == tag.tagId)) {
                    tag.isSelected = true;
                }

                fb.patchValue(tag);
                tags.push(fb);

                if (tag.isSelected)
                    this.SelectedTags.push(fb); //this is to keep a separate tab of the selected tags

            });

        }

        if (this.clearanceItemForm.controls.selectedTags.value.length == 0) {   //this forces the validation messages to kick in
            //we do this all the time as at least one global tag is needed
            this.clearanceItemForm.controls.selectedTags.markAsDirty()
            this.clearanceItemForm.controls.selectedTags.updateValueAndValidity();
        }

        this.statusChangeComments = null;

        let restrictions = <FormArray>this.clearanceItemForm.controls['restrictions'];

        if (restrictions && restrictions.controls && restrictions.controls.length > 0) {
            restrictions.controls = [];
        }
        if (this.allRestrictions)
            this.allRestrictions.forEach(rest => {
                const fb = this.initRest(rest);
                fb.patchValue(rest);
                restrictions.push(fb);
            });

        let images = this.ImagesControl;
        images.controls = [];

        let imagesRef = this.ImagesRefControl;
        imagesRef.controls = [];

        if (this.images && this.images.length > 0) {
            this.images.forEach(img => {
                var fb: FormGroup;
                fb = this.imageComponent ? this.imageComponent.initAsset(img) : this.fb.group(img);
                fb.patchValue(img);
                if (img.assetType == 'Image') {
                    images.push(fb);
                } else {
                    imagesRef.push(fb);
                }
            });

            //get the default image (as flagged in the database)
            var defImg = images.controls.find(i => i.value.defaultC);

            //if no default image, then try any image on the non-ref list first
            if (!defImg) {
                if (images.length > 0) {
                    defImg = images.controls[0];
                    defImg.get('defaultC').setValue(true);
                }
                else if (imagesRef && imagesRef.length > 0) {
                    defImg = imagesRef.controls[0];
                }
            }

            //there will allways be one default if there is at least one image
            this.defaultImageChanged(defImg as FormGroup);

            this._clearanceItemService.getOriginalImagesFullUrls(this.clearanceItem).forEach(signedUrlObserver => {
                signedUrlObserver.subscribe((data)=>{
                    this.setFullImageSignedUrl(data);
                });
            });
        }


        images.updateValueAndValidity();
        imagesRef.updateValueAndValidity();

        let docs = <FormArray>this.clearanceItemForm.controls['documents']
        docs.controls = [];

        if (this.documents)
            this.documents.forEach(doc => {
                const fb = this.documentComponent ? this.documentComponent.initAsset(doc) : this.fb.group(doc);
                fb.patchValue(doc as any);
                docs.push(fb);
            });
        docs.updateValueAndValidity();

        this.updateFormWithTitles();

        this.setStatusControlState();
        this.setVisibleStatuses();
        this.initMaterial();

        this.formFullyLoaded = true;

    }

    get ImagesControl(): FormArray {
        return <FormArray>this.clearanceItemForm.get('images');
    }

    get ImagesRefControl(): FormArray {
        return <FormArray>this.clearanceItemForm.get('imagesRef');
    }

    initRestrictions(selected: boolean = false): FormGroup[] {
        var groups = [];
        if (this.allRestrictions)
            for (let rest of this.allRestrictions) {
                groups.push(this.initRest(rest));
            }
        return groups;

    }

    initRest(rest: CIRestriction): FormGroup {
        return this.fb.group({
            restrictionType: rest.restrictionType,
            description: new FormControl({ value: rest.description, disabled: false }),
            isSelected: rest.isSelected,
            id: rest.id,
            pinned: rest.pinned || false
        });

    }

    formFullyLoaded: boolean = false;

    ngAfterViewInit() {

        SharedUtils.RemoveTooltipIfNeeded();

        this.initMaterial();
        //Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        merge(this.clearanceItemForm.valueChanges, ...controlBlurs).pipe(
            debounceTime(500),
        ).subscribe(value => {
            DateUtils.normalizeMaterialDateControl(this.clearanceItemForm.controls['deadline']);
            this.displayMessage = this.genericValidator.processMessages(this.clearanceItemForm);
            // this.Autosave();
        });

        if (this.clearanceItemForm.controls['deadline']) {
            this.clearanceItemForm.controls['deadline'].valueChanges.subscribe((value) => {
                if (document && document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }
            });
        }

        // moved the animation here since it was interfering with the material modal window (showing behind the main overlay)
        SharedUtils.FixFlickering();

    }

    Autosave(cb: () => void) {

        console.log('this.clearanceItemForm.valueChanges...this.formFullyLoaded:' + this.formFullyLoaded);

        if (!this.formFullyLoaded)
            return;

        if (this.clearanceItemForm.dirty && this.clearanceItemForm.valid) {

            this.autosave = true;
            console.log('Saving...');

            var itemToSave = this.gatherDataFromForm();

            this._clearanceItemService.saveClearanceItem(itemToSave)
                .subscribe(ci => {
                    
                    if (!itemToSave.id)
                        this.onClearanceItemSaved(ci);

                    this.clearanceItemForm.markAsPristine();
                    if (cb)
                        cb();
                },
                    err => {
                        this._errorHandler.processError(err);
                    }, () => this.autosave = false);

        }

    }

    @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        return !this.clearanceItemForm.dirty;
    }

    initMaterial() {}

    getClearanceItem(ciId: string): void {
        this.showSpinner = true;
        this._clearanceItemService.postCreateOptimizedImages(ciId);
        let self = this;
        forkJoin(this._appService.retrieveCILookups(undefined, this.projectId, true), this._clearanceItemService.getCI(ciId))
            .subscribe
            (
                (data) => {
                    this.onLookupsRetrieved(data[0]);
                    this.onCIRetrieved(data[1]);
                    this.updateForm();
                    this.openCarousel();
                    this.showSpinner = false;
                },
                (error: any) => {
                    this.showSpinner = false;
                    if (error.status === 403) {
                        this._notificationsService.add(new Notification('error', 'Access denied. You do not have permissions to view this Clearance Item.'));
                        this.router.navigate(['/dashboard/'+self.projectId]);
                    } else {
                        this._errorHandler.processError(error);
                    }
                }
            );

    }
    loadCILookups(): void {
        this._appService.retrieveCILookups(undefined, this.projectId, true)
            .subscribe(
                (list) => {
                    if (list) {
                        console.log(list);
                        this.onLookupsRetrieved(list);
                        this.updateForm();
                    }
                },
                (error) => {
                    // this.errorMessage = <any>error;
                    this._errorHandler.processError(error);
                }
            );

    }
    // sort(tags: CITag[], ascdes:string='asc'): CITag[] {

    //     // let ascdesc = this.sortingFields[field];
    //     let ascdesc = 'asc';
    //     return orderBy(tags, ['tagName'], [ascdesc]);
    // }

    onLookupsRetrieved(list: LookupList[]): void {
        if (list && list.length > 0) {
            if (list.find(it => it.lookupType == 'CIStatus') != null){
                this.statusLookup = list.find(it => it.lookupType == 'CIStatus').lookupData;
                this.setVisibleStatuses();
            }
            if (list.find(it => it.lookupType == 'Tags') != null) {
                var lookupData = list.find(it => it.lookupType == 'Tags').lookupData;
                if (lookupData) {
                    this.globalTags = [];
                    lookupData.forEach(lookup => {
                        var ciTag: CITag = new CITag();
                        ciTag.tagId = lookup.id;
                        ciTag.tagName = lookup.name;
                        ciTag.tagType = lookup.type;
                        ciTag.icon = 'bookmark';
                        this.globalTags.push(ciTag);
                    });
                    this.globalTags = AppUtils.SortTags(this.globalTags);
                }
            }
            if (list.find(it => it.lookupType == 'CIRestrictions') != null) {
                var lookupData = list.find(it => it.lookupType == 'CIRestrictions').lookupData;
                if (lookupData) {
                    this.allRestrictions = [];
                    lookupData.forEach(lookup => {
                        var ciRestriction: CIRestriction = new CIRestriction();
                        ciRestriction.restrictionType = lookup.name;
                        this.allRestrictions.push(ciRestriction);
                    });
                }
            }
        }


    }

    get FullPageTitle(): string {
        console.log('this.clearanceItem.ciUniqueId: ' + this.clearanceItem.ciUniqueId);
        if (this.clearanceItem.ciUniqueId) {
            return this.clearanceItem.ciUniqueId;
        } else {
            if (this.clearanceItem.id) {
                this.clearanceItemForm.markAsDirty();
                return '[No Id, save to get New id]';
            }

            return 'New Item';
        }
    }

    onCIRetrieved(ci: ClearanceItem): void {

        // console.log('ClearanceItemComponent.onCIRetrieved(ci) >> ci:' + JSON.stringify(ci));

        if (ci) {
            this.clearanceItem = ci;
            this.pageTitle = this.FullPageTitle;
            this.titleList = ci.titles;
            //loop through all tags of ci and add them to global tags to show in UI.
            if (this.globalTags && this.clearanceItem.tags && this.clearanceItem.tags.length > 0) {
                this.clearanceItem.tags.forEach(tag => {
                    var staticTag = this.globalTags.find(it => it.tagName == tag.tagName);
                    if (staticTag) {
                        staticTag.isSelected = true;
                        staticTag.id = tag.id;
                        staticTag.tagId = tag.tagId;
                    }
                    else {
                        tag.isSelected = true;
                        tag.icon = 'bookmark';
                        tag.tagType = 'Custom';
                        this.globalTags.push(tag);
                    }
                });
            }

            //reset the descriptions only
            for (let r of this.allRestrictions) {
                r.description = null;
            }
            if (this.allRestrictions && this.clearanceItem.restrictions && this.clearanceItem.restrictions.length > 0) {
                this.clearanceItem.restrictions.forEach(rest => {
                    var existingType = this.allRestrictions.find(it => it.restrictionType == rest.restrictionType);
                    if (existingType) {
                        existingType.isSelected = true;
                        existingType.id = rest.id;
                        existingType.description = rest.description;
                        existingType.pinned = rest.pinned;
                    }

                });
            }

            if (this.images && this.clearanceItem.images && this.clearanceItem.images.length > 0) {
                this.images = [];
                this.clearanceItem.images.forEach(img => {
                    this.images.push(img);
                });
            }

            if (this.documents && this.clearanceItem.documents && this.clearanceItem.documents.length > 0) {
                this.documents = [];
                this.clearanceItem.documents.forEach(doc => {
                    this.documents.push(doc);
                });
            }

            this.showDeleteBtn = true;
            this.showCopyBtn = true;

        }
    }

    restictionChecked(rest: FormGroup): void {
        // if (rest)
        // rest.controls.description.reset({ value: '', disabled: false })
        // if(rest.controls.isSelected.value)
        // rest.patchValue({ description:  new FormControl({value: '', disabled: false})  });
        //     else
        //     rest.patchValue({ description:  new FormControl({value: '', disabled: true})  });
        this.initMaterial();
    }

    promptOptions: PromptOptions = { header: 'Delete Item', body: '' };
    promptSubscription: Subscription;

    deleteItem(): void {
        if (this.clearanceItem && this.clearanceItem.id) {
            this.promptOptions.body = 'Are you sure you want to delete this item?';
            this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).pipe(first())
                .subscribe(
                    answerWasYes => {
                        if (answerWasYes) {
                            console.log('about to delete this.clearanceItem.id: ' + this.clearanceItem.id);
                            this._clearanceItemService.deleteClearanceItem(this.clearanceItem.id)
                                .subscribe(status => {
                                    if (status) {
                                        this._messageBrokerService.itemHasBeenDeleted(this.clearanceItem.id);
                                        let self = this;
                                        self._notificationsService.add(new Notification('success', 'Clearance Item deleted successfully.'));
                                        self.clearanceItemForm.markAsPristine();
                                        let previous = this.resolveReturnToCiListUrl();
                                        if (previous && previous !== '/') {
                                            previous = AppUtils.replaceQueryParam(previous, 't', Date.now().toString());
                                        }
                                        this.router.navigateByUrl(previous);
                                    }
                                    else {
                                        this._notificationsService.add(new Notification('error', 'Failed to Delete Item, Please try again later.'));
                                    }

                                },
                                    err => {
                                        this._errorHandler.processError(err);
                                    });
                        }
                    });

        }
    }
    copyItem(): void {

        if (!this.clearanceItemForm.valid)
            return;

        if (this.clearanceItemForm && this.clearanceItemForm.valid && this.clearanceItemForm.dirty) {
            //TODO
            this.saveClearanceItem(true);
        }
        else if (this.clearanceItem && this.clearanceItem.id) {
            this.resetItemDetails(true);
        }
        this.focusItemName();

    }
    deleteCustomTagFromUI(selectedTag)
    {
          //find tag from main list
          var tags=<FormArray>this.clearanceItemForm.controls['tags'];
        var existingTag = tags.controls.find(it => it.value.tagName.toUpperCase() == selectedTag.controls.tagName.value.toUpperCase());
        if (existingTag) {
            tags.controls=tags.controls.filter(tag=>tag.value.tagName !== existingTag.value.tagName)
        }
        //delete from selected Tags
        
        let sc = this.SelectedTags.controls.findIndex(it => it.value.tagName.toUpperCase() == selectedTag.controls.tagName.value.toUpperCase());
        if (sc != -1) {
            this.SelectedTags.removeAt(sc);
        }
        let gcIndex = this.globalTags.find(it => it.tagName.toUpperCase() == selectedTag.controls.tagName.value.toUpperCase());
        if (gcIndex) {
            this.globalTags=this.globalTags.filter(tag=>tag.tagName !== gcIndex.tagName);
        }
        this.clearanceItemForm.controls.selectedTags.markAsDirty()
        this.clearanceItemForm.controls.selectedTags.updateValueAndValidity();
        
        this._notificationsService.add(new Notification('success', 'Tag deleted sucessfully.'));
    }
    resetItemDetails(copyData: boolean = false) {

        this.isNewCI = true;
        this.location.replaceState('/projects/' + this.projectId + '/items/new');
        this.clearanceItem.id = null;
        this.pageTitle = 'New Item';
        this.showDeleteBtn = false;
        this.clearanceItem.ciUniqueId = null;

        this.clearanceItem.status = this._authService.secondApproval ? 'APPROVAL PENDING' : 'NEW';
        this.clearanceItem.images = [];
        this.clearanceItem.documents = [];
        this.images = [];
        this.documents = [];
        this.titleList = [];
        this.clearanceItem.tags = null;
        this.clearanceItem.selectedTags = null;
        this.clearanceItem.restrictions = null;
        this.defaultImageUrl = null;
        this.allRestrictions.forEach(it => {
            it.id = null;
            it.cIId = null;
        });
        if (copyData) {
            this.globalTags.forEach(it => {
                it.id = null;
                it.cIId = null;
            });

            this.clearanceItem.name = 'Copy of ' + this.clearanceItem.name;
            this._notificationsService.add(new Notification('info', 'Item details are copied '));
        }
        else {
            //refresh lookups
            this.loadCILookups();
            this.clearanceItem.name = null;
            this.clearanceItem.artistAuthorName = null;
            this.clearanceItem.copyrightInfo = null;
            this.clearanceItem.reportGroupName = null;
            this.clearanceItem.description = null;
            this.clearanceItem.isCreatedByProd = false;
            this.clearanceItem.refUrl = null;
            this.clearanceItem.scene = null;
            this.clearanceItem.episode = null;
            this.clearanceItem.season = null;
            this.clearanceItem.deadline = null;
        }
        this.updateForm();
        this.clearanceItemForm.markAsDirty();

        this.focusItemName();

    }
    createNew(): void {

        if (!this.clearanceItemForm.valid)
            return;

        if (this.projectId) {

            if (this.clearanceItemForm.dirty) {
                this.promptOptions.header = "Item has changed"
                if (!this.clearanceItemForm.valid) {
                    this.promptOptions.body = 'Would you like to discard your changes?';
                    this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).pipe(first()).subscribe(r => {
                        if (r) {
                            this.resetForm();
                        }
                    });
                } else {
                    // this.promptOptions.body = 'Would you like to save your changes?';
                    // this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).first().subscribe(r => {
                    //     if (r) {
                    this.Autosave(this.resetForm.bind(this));
                    //     }
                    // });
                }
            } else {
                this.resetForm();
            }
        }
    }

    resetForm() {
        this.resetItemDetails(false);
        this.focusItemName();
    }
    downloadAllAssets()
    {
        this.imageComponent.downloadAll();
        this.imageRefComponent.downloadAll();
        this.documentComponent.downloadAll();
    }
    gatherDataFromForm(): ClearanceItem {

        var itemToSave = <ClearanceItem>Object.assign({}, this.clearanceItem, this.clearanceItemForm.value);
        itemToSave.projectId = this.projectId;
        itemToSave.id = this.clearanceItem.id;
        itemToSave.deadline = DateUtils.toApiDate(itemToSave.deadline);
        itemToSave.restrictions = itemToSave.restrictions.filter(it => it.description);
        itemToSave.tags = itemToSave.selectedTags;

        itemToSave.titles = itemToSave.titles.map((t, i) => {
            t.isDefault=false;
            t.order = i + 1;
            return t
        });

        let defaultTitle = itemToSave.titles.find(t => t.id == this.defaultTitle);

        if (defaultTitle) {
            defaultTitle.isDefault = true;
            itemToSave.name = defaultTitle.name;
        }

        if (this.statusChangeComments)
            itemToSave.statusChangeComments = this.statusChangeComments;

        itemToSave.images = itemToSave.images.map((img, i)=>{
            img.originalImageFullUrl = null;
            img.order = i + 1;
            return img;
        });

        itemToSave.imagesRef = itemToSave.imagesRef.map((img, i)=>{
            img.originalImageFullUrl = null;
            img.order = i + 1;
            return img;
        });

        itemToSave.documents = itemToSave.documents.map((doc, i)=>{
            doc.order = i + 1;
            return doc;
        })

        itemToSave.images = itemToSave.images.concat(itemToSave.imagesRef);

        return itemToSave;
    }


    saveClearanceItem(copyItem: boolean = false, closeForm: boolean = false): void {
        if (this.clearanceItemForm.dirty && this.clearanceItemForm.valid) {

            this.showSpinner = true;

            var itemToSave = this.gatherDataFromForm();

            this._clearanceItemService.saveClearanceItem(itemToSave)
                .subscribe(ci => {
                    
                    this._messageBrokerService.itemHasChanged(ci);
                    this.onClearanceItemSaved(ci, copyItem, closeForm);
                    this.showSpinner = false;
                },
                    err => {
                        
                        var e = JSON.stringify(err);

                        if(e.indexOf("AntiXssMiddleware") !== -1 || err.includes("AntiXssMiddleware")){
                            this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));
                            this.showSpinner = false;
                        }
                        else{
                            this.showSpinner = false;
                            this._errorHandler.processError(err);
                        }

                        
                    });

        }
    }

    onClearanceItemSaved(ci: ClearanceItem, copyItem: boolean = false, closeForm: boolean = false) {

        if (ci && ci.id) {
            this.clearanceItemForm.markAsPristine();

            this._notificationsService.add(new Notification('success', 'Clearance Item saved successfully.'));
            this.isNewCI = false;
            this.onCIRetrieved(ci);
            this.updateForm();
            this._messageBrokerService.sendMessageToRefreshLeftNav('');
            if (copyItem) {
                this.copyItem();
            }
            if (closeForm) {
                this.cancelClicked();
            }
            else {
                
                
                this.location.replaceState('/projects/' + this.projectId + '/items/' + ci.id);
            }
        }
        else {
            this._notificationsService.add(new Notification('error', 'Failed to save Clearance Item, Please try again later.'));

        }
    }

    cancelClicked(): void {
        let previous = this.resolveReturnToCiListUrl();
        if (previous && previous!='/')
            previous = AppUtils.replaceQueryParam(previous, 't', Date.now().toString());
        this.router.navigateByUrl(previous);
    }

    /** Prefer listViewURL (includes Filter by Status from replaceState) over stale NavigationEnd history. */
    private resolveReturnToCiListUrl(): string {
        let previous = this.navigationTracker.getPreviousCiListSearch();
        const listView = this._appService.listViewURL;
        const isProjectItems = (url: string) =>
            /^\/projects\/[A-Za-z0-9-]+\/items(?:\?.*)?$/i.test(url || '');
        if (listView && isProjectItems(listView) && (previous === '/' || isProjectItems(previous))) {
            previous = listView;
        }
        return previous;
    }


    defaultImageUrl: string = '';

    get imagesOnly(): CIImage[] {
        return this.clearanceItemForm.controls.images.value.filter(i => i.assetType.toLowerCase() === "image");
    }

    defaultImageChanged(asset: FormGroup) {
        if (asset) {
            let id = asset.value.id;
            let imgDefault = this.imagesOnly.find(i => i.id == id);
            
            if (imgDefault) {
                this.imagesOnly.forEach(i => i.defaultC = false);
                imgDefault.defaultC = true;
                this.defaultImageUrl = imgDefault.fullUrl;
            } else {
                this.defaultImageUrl = '';
            }
        } else {
            this.defaultImageUrl = '';
        }
    }

    statusChanged(): void {
        this.clearanceItemForm.controls['status'].valueChanges.subscribe((value) => {
            //check if it is not same as current status
            if ((value === 'PENDING - Production Info Required' || value === 'PENDING - Modifications Required' || value == 'DEFERRED' || value == 'DENIED') && value != this.clearanceItem.status) {
                this.statusChangeComments = null;
                this.showStatusChangeModal = true;
            }

        });
    }
    changeStatusComments(): void {
        if (!this._authService.secondApproval) {
            if (!this.statusChangeComments) {
                this._notificationsService.add(new Notification('warn', 'Please enter comments or click change without comments to update the status, or click cancel to revert back.',"", false));
            }
            else{
                this.showStatusChangeModal = false;
            }
        }
        else{
            this.showStatusChangeModal = false;
        }

    }

    changeStatusWithoutComments(): void {
        this.statusChangeComments = null;
        this.showStatusChangeModal = false;
    }

    cancelStatusChange(): void {
        console.log(this.clearanceItem.status);
        if (this.clearanceItem.status) {
            this.clearanceItemForm.patchValue({ status: this.clearanceItem.status });
            //his.clearanceItemForm.controls['status'].patchValue({ value: this.clearanceItem.status });
        }
        this.showStatusChangeModal = false;

    }

    ProcessSearch(): void {
        this._clearanceItemService.searchTerm(this.clearanceItemForm.controls['reportGroupName'].valueChanges, this.projectId, 100, 'reportGroups')
            .subscribe(searchResults => {

                // console.log('searchResults: ' + JSON.stringify(searchResults));
                this.searchResults = searchResults.find(r => r.lookupType == 'reportGroups').lookupData;
                this.filteredReportGroups = this.searchResults ? this.searchResults.map(r => r.name) : [];
            }, err => {
                if (err.status != 404) {
                    this._errorHandler.processError(err);
                }
            });
    }

    escapeDoubleQuotes(str: string): string {
        if (!str)
            return '';
        return str.replace(/\\([\s\S])|(")/g, "\\$1$2"); // thanks @slevithan!
    }

    static minLengthArray(min: number, isClearanceUser: boolean) {
        //per SCR-371 this is no longer needed, re: SCR-292
        //console.warn('validation');
        // if (isClearanceUser){
        //     return null;
        // }

        return (c: AbstractControl): { [key: string]: any } => {
            if (c.value.length >= min) {
                return null;
            }
            return { 'minLengthArray': { valid: false } };
        }
    }

    canItemBeDeleted(): boolean {
        return this.isClearanceUser || (this.clearanceItemForm && this.clearanceItemForm.controls && this.clearanceItemForm.controls.status && this.clearanceItemForm.controls.status.value == 'NEW');
    }

    // showMoreTitles() {       
    //     $('#modal-other-titles').modal('open');
    //     this.clearNewTitleAndFocus();  
    // }
    addTtitle(index: number) {

        let controlsCount = this.titles.controls.length;
        if (index == -1) {
            //this just attempts to 'reuse' any available spot (to avoid cluttering with multiple rows)
            if (controlsCount > 0 && this.titles.value[controlsCount - 1].name.trim() == '') {
                let itemName = '#itemName' + (controlsCount - 1);
                setTimeout(() => {
                    const input = document.querySelector(itemName) as HTMLInputElement;
                    if (input) {
                        input.focus();
                        input.select();
                    }
                }, 10);
                return;
            }

            this.titles.push(this.initTitle(new ILookup(Guid.MakeNew().ToString(), '', 'title', false, 0), this.defaultTitle));
            let itemName = '#itemName' + (this.titles.controls.length - 1);
            setTimeout(() => {
                const input = document.querySelector(itemName) as HTMLInputElement;
                if (input) {
                    input.focus();
                }
            }, 10);
        }
        else {
            this.promptOptions.body = 'Are you sure you want to delete aka title?';
            this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).pipe(first())
                .subscribe(
                    answerWasYes => {
                        if (answerWasYes) {
                            this.titles.removeAt(index);
                          
                        }
                    });  
           
        }
        this.titles.markAsDirty();
    }

    clearNewTitleAndFocus() {
        this.newTitle.nativeElement.value = '';
        this.newTitle.nativeElement.focus();
        this.newTitle.nativeElement.select();
    }

    defaultTitle: string = '';
    onItemSelectionChange(e) {
        this.defaultTitle = e;
    }

    updateTitles() {
        this.updateFormWithTitles()
        this.clearanceItemForm.markAsDirty();
    }

    updateFormWithTitles() {

        //update the default
        //clear the formarray, **note: controls = [] won't do
        this.clearTitles();

        //add the default
        if (!this.titleList.find(t => t.order == 1)){
            var newId = Guid.MakeNew().ToString();
            let defaultItem = this.initTitle(new ILookup(newId, this.clearanceItem.name, 'title', true, 1), newId)
            this.defaultTitle = defaultItem.get('id').value;
            this.initialDefaultTitle = defaultItem.get('id').value;
            this.titles.push(defaultItem);
        }
        else{
            var defaultItemList = this.titleList.find(t => t.isDefault == true);
            this.defaultTitle = defaultItemList.id;
            let defaultItem = this.initTitle(new ILookup(defaultItemList.id, defaultItemList.name, 'title', defaultItemList.isDefault, defaultItemList.order), defaultItemList.id);
            this.titles.push(defaultItem);
            this.initialDefaultTitle = defaultItem.get('id').value;
        }

        //add the rest
        this.titleList.filter(ti => ti.id != this.defaultTitle).forEach(t => {
            let tg = this.initTitle(new ILookup(t.id, t.name, 'title', t.isDefault, t.order), this.defaultTitle)
            this.titles.push(tg)
        });
    }

    clearTitles() {
        while (this.titles.length) {
            this.titles.removeAt(0);
        }
    }

    initTitle(title: ILookup, defaultTitle: string = ''): FormGroup {
        var parent = this;
        let t = this.fb.group({
            id: title.id,
            name: title.name,
            type: 'title',
            defaultTitle: defaultTitle,
            isDefault: title.isDefault,
            order: title.order
        });
        t.controls.defaultTitle.valueChanges.subscribe(t => {
            this.titles.markAsDirty();
            console.log('def titles changing to:' + t);
            this.defaultTitle = t;
            var defaultItem = parent.titles.controls.find(title => title.get('id').value == t);
            this.updatedCIName = defaultItem.get('name').value;
        });

        return t;

    }

    get titles(): FormArray {
        return this.clearanceItemForm.controls.titles as FormArray;
    }

    private setFullImageSignedUrl(signedUrl){
        if (this.images) {
            if (this.imageComponent){
                this.imageComponent.updateOriginalImageFullUrl(signedUrl);
            }
            if (this.imageRefComponent){
                this.imageRefComponent.updateOriginalImageFullUrl(signedUrl);
            }
            
        }
    }

    refURLChanged($event: string){
        this.clearanceItemForm.controls.refUrl.setValue($event);
        this.clearanceItemForm.controls.refUrl.markAsDirty();
    }

    onCINameChanged(ciName: string){
        var currentDefaultItem = this.titles.controls.find(t => t.get('id').value == this.initialDefaultTitle);
        currentDefaultItem.get('name').setValue(ciName);
    }

    setEpisodeValidation() {
        if (this.projectDepartment == "TV")
        {
            this.clearanceItemForm.get('episode').setValidators(Validators.required);
            if (this.isNewCI) {
                this.clearanceItemForm.get('episode').markAsDirty();
            }
            this.clearanceItemForm.get('episode').updateValueAndValidity();
        }
    }

    openCarousel(){
        if (!this.openCarouselAssetType){
            return;
        }

        if (this.openCarouselImageIndex == null || this.openCarouselImageIndex == undefined || isNaN(this.openCarouselImageIndex)){
            return;
        }

        setTimeout(() => this.tryOpenCarousel(0), 700);
    }

    private tryOpenCarousel(attempt: number): void {
        const maxAttempts = 12;
        const retryDelayMs = 300;
        const assetType = this.openCarouselAssetType.toLowerCase();
        let targetComponent: ClearanceItemAssetManagerComponent;

        if (assetType === 'image') {
            targetComponent = this.imageComponent;
        } else if (assetType === 'reference') {
            targetComponent = this.imageRefComponent;
        } else {
            console.log('assetType not found');
            return;
        }

        if (!targetComponent) {
            console.log('targetComponent not found');
            if (attempt < maxAttempts) {
                setTimeout(() => this.tryOpenCarousel(attempt + 1), retryDelayMs);
            }
            return;
        }

        if (this.openCarouselImageIndex < 0) {
            console.log('openCarouselImageIndex < 0');
            return;
        }

        console.log('opening carousel');
        targetComponent.openCarousel(this.openCarouselImageIndex);
        setTimeout(() => {
            if (targetComponent.carousel) {
                targetComponent.carousel.ngOnChanges();
            }
            else{
                console.log('carousel not found');
            }
        }, 100);

        if (!targetComponent.showCarousel && attempt < maxAttempts) {
            setTimeout(() => this.tryOpenCarousel(attempt + 1), retryDelayMs);
        }
    }


    enableTags() {
        return this.clearanceItemForm 
            && this.clearanceItemForm.controls 
            && this.clearanceItemForm.controls.status 
            && PENDING_STATUSES.has(this.clearanceItemForm.controls.status.value.toUpperCase());
    }

    showRestriction(restrictionType){
        var productionUser = !this.isClearanceUser && restrictionType === 'Notes';
        var snpUser = this.isClearanceUser && this._authService.secondApproval && restrictionType !== 'Notes';
        var clearanceUser = this.isClearanceUser && !this._authService.secondApproval && restrictionType !== 'Notes S&P'
        return productionUser || snpUser || clearanceUser;
    }
    
    ciStatusChange($event){
        this.clearanceItemForm.controls.status.setValue($event.ciStatus);
    }

    setStatusControlState(){
        const statusCtrl = this.clearanceItemForm.get('status');

        if (this.isClearanceUser) {
           this.clearanceItemForm.controls['status'].enable();
        }
        else if (!this.isClearanceUser && statusCtrl.value === 'NEW') {
            this.clearanceItemForm.controls['status'].enable();
        }
        else  {
            this.clearanceItemForm.controls['status'].disable();
        }
    }

    setVisibleStatuses(): void {
        const currentStatus = this.clearanceItemForm.get('status')!.value;

        if (this.isClearanceUser) {
            this.visibleStatusLookup = this.statusLookup;
            return;
        }

        if (currentStatus === 'NEW') {
            this.visibleStatusLookup = this.statusLookup.filter(s => this.allowedStatusesForProductionUsers.has(s.name));
            return;
        }

        this.visibleStatusLookup = this.statusLookup;
    }

    onReportGroupSelected(tagName: string): void {
        if (tagName) {
            this.clearanceItemForm.get('reportGroupName').setValue(tagName);
        }
    }

    stopPropagation(event: Event): void {
        if (event) {
            event.stopPropagation();
        }
    }

    private focusItemName(): void {
        setTimeout(() => {
            if (this.itemNameInput && this.itemNameInput.nativeElement) {
                this.itemNameInput.nativeElement.focus();
                this.itemNameInput.nativeElement.select();
            }
        });
    }

    toggleRestrictionPin(event: Event, rest: FormGroup): void {
        event.preventDefault();
        event.stopPropagation();
        rest.controls.pinned.setValue(!rest.controls.pinned.value);
        rest.markAsDirty();
        this.clearanceItemForm.markAsDirty();
    }
}
